import { render } from "./AddNewCheque.vue?vue&type=template&id=39d2c10d"
import script from "./AddNewCheque.vue?vue&type=script&lang=js"
export * from "./AddNewCheque.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__